/**
 * Company: SPHMedia
 * Description: [Brief description of the component]
 */
import { FacebookShareButton, TwitterShareButton } from "react-share";
import { faFacebookF, faXTwitter } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cn } from "@util/helpers";
import cx from "classnames";

export type SocialMediaIconsProps = {
  /** Optional className for the component. */
  className?: string;
  /** The URL to share. */
  shareUrl: string;
};

/**
 * The social media icons used in lifestyle card layout.
 */
const SocialMediaIcons = ({
  className,
  shareUrl,
}: SocialMediaIconsProps): React.ReactElement => {
  const iconClassNameValues = cx(
    "relative flex h-8 w-8 items-center justify-center rounded-full !border !border-gray-300 z-0 transition-colors !border-solid",
    "after:absolute after:-bottom-[1px] after:-left-0 after:-right-0 after:shadow-socialShadow after:top-1/2 after:block after:bg-white",
    "group-hover:!border-lifestyle-primary"
  );

  return (
    <div className={cn("mr-12 flex flex-row space-x-2", className)}>
      <FacebookShareButton url={shareUrl} className={iconClassNameValues}>
        <FontAwesomeIcon
          icon={faFacebookF}
          className="group-hover:text-life z-10 text-gray-300 transition-colors group-hover:text-lifestyle-primary"
        />
      </FacebookShareButton>

      <TwitterShareButton url={shareUrl} className={iconClassNameValues}>
        <FontAwesomeIcon
          icon={faXTwitter}
          className="group-hover:text-life z-10 text-gray-300 transition-colors group-hover:text-lifestyle-primary"
        />
      </TwitterShareButton>
    </div>
  );
};

export default SocialMediaIcons;
